import { createContext, useContext } from 'react';
import type { Api } from './api/client';
import type { Me } from './types';

export const ApiContext = createContext<Api | null>(null);
export const MeContext = createContext<Me | null>(null);

export function useApi(): Api {
  const api = useContext(ApiContext);
  if (!api) throw new Error('useApi outside ApiContext');
  return api;
}

export function useMe(): Me {
  const me = useContext(MeContext);
  if (!me) throw new Error('useMe outside MeContext');
  return me;
}
